module.exports = __webpack_public_path__ + "img/home-kurs-2.9d9e9930.png";